import { BodyText, Tag } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import { NyhetsBlockResponse } from '../../types/blocks';
import { NyhetResponse, NyhetsarkivResponse } from '../../types/pages';
import styles from './NyhetContent.module.css';
import Nyhetstag from './Nyhetstag';

export type Nyheter = NyhetsarkivResponse | NyhetsBlockResponse;

type NyhetContentProps = {
  nyhet: NyhetResponse;
};

const NyhetContent: FC<NyhetContentProps> = ({ nyhet }): ReactNode => {
  const formatDate = (date: Date): string => {
    return new Date(date).toLocaleDateString(navigator.language, { month: 'long', day: 'numeric' });
  };

  return (
    <div className={styles.container}>
      <BodyText className={styles.datum} size="textLarge">
        {formatDate(nyhet.publiceringsdatum)}
        {nyhet.notis && (
          <Tag className={styles.kategori} text="Notis" variant="neutral" />
        )}
      </BodyText>
      <BodyText className={styles.title} color={nyhet.notis ? undefined : 'darkBlue'}>
        {nyhet.rubrik}
      </BodyText>
      <BodyText className={styles.subtitle}>
        {nyhet.teasertext}
      </BodyText>
      <Nyhetstag nyhet={nyhet} />
    </div>

  );
};

export default NyhetContent;
